// extracted by mini-css-extract-plugin
export var activityContainer = "_ng-0";
export var typingIndicatorContainer = "_ng-1";
export var typingIndicatorDot = "_ng-2";
export var wave = "_ng-3";